import React, {useEffect } from 'react'
import { gql, useMutation } from '@apollo/client'
import Modal from 'styled-react-modal'
import styled from 'styled-components'

import {
  Button,
  Input,
} from '../StyledComponents.js'
import {
  Wrapper,
} from '../StyledComponents.js'
import {loggedInContext} from '../auth/AuthContext'
import { useCsEvent } from '../client/useEvents.js'
import Spinner from './Spinner';
import { toast } from 'react-toastify'

const StyledModal = Modal.styled`
  margin-left: auto;
  margin-right: auto;
  margin-top: 1em;
  background-color: white;
  border: .5em;
  border-style: solid;
  border-color: gray;
  padding: 1em;
  width: 85vw;
  @media(min-width: 960px) {
    width: 80vw;
  }
`
const Row = styled.div`
  position: relative;
  margin-top: 1em;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  justify-content: center;
  @media(min-width: 960px) {
    width: 50%;
  }
`
const FormButton = styled(Button)`
    font-family: NeueEinstellungBold;
    text-align: center;
    white-space: nowrap;
    line-height: 1.5;
    font-size: 1.6rem;
    background-color: rgb(139, 125, 101);
    border: 0.1rem solid rgb(139, 125, 101);
    color: white;
    outline: 0px;
    display: block;
    font-weight: 500;
    width: 100%;
}
`
const FormInput = styled(Input)`
    font-family: NeueEinstellungRegular;
    padding: 1.6rem 1.2rem;
    width: 100%;
    outline: 0px;
    border: 0.1rem solid rgb(221, 221, 221);
    border-radius: 0px;
    font-size: 1.6rem;
    appearance: none;
    box-sizing: border-box;
`
const FormLabel = styled.label`
    transform: translate(0px, -75%);
    font-size: 0.9rem;
    background: transparent;

    font-family: NeueEinstellungRegular;
    position: absolute;
    left: 1.2rem;
    top: 1.6rem;
    color: rgb(118, 118, 118);
    line-height: 1.5;
    transition: transform 150ms ease-out 0s, font-size 150ms ease-out 0s;
    pointer-events: none;
`
const ErrorDiv = styled.div`
    font-family: NeueEinstellungRegular;
    font-size: 1rem;
    line-height: 1;
    padding: 1rem;
    position: relative;
    margin-bottom: 1rem;
    color: rgb(219, 41, 41);
    border: 0.1rem solid rgb(219, 41, 41);
}
`

const createMutation = gql`
  mutation create($title: String!, $items: [JSONObject]) {
    createCollection(title: $title, items: $items)
  }
`

function Component(props) {
  const titleRef = React.useRef()
  const {loggedIn, logIn, loginCta, openSignupModal} = React.useContext(loggedInContext) 
  const [errorDisplay, setErrorDisplay] = React.useState(null)
  const fireCsEvent = useCsEvent()
  const {item} = props

  const [createCollection, 
    {
      called, 
      loading, 
      data,
      error
    }
  ] = useMutation(createMutation, {
    onCompleted: (data) => {
      console.debug("Create collection on completed data:", data)
      if (data) {
        toast.success("Yeni koleksiyonuz oluşturuldu, hesap sayfasından görebilirsiniz!");
      }
      closeModal()
    },
    errorPolicy: 'all' 
  })

  if ((!errorDisplay && error?.message)
    || (errorDisplay && errorDisplay !== error?.message)) {
    setErrorDisplay(error.message)
  }

  function afterOpenModal() {
    // references are now sync'd and can be accessed.
  }

  function closeModal() {
    props.onClose && props.onClose()
  }

  const onCreate = () => {
    const title = titleRef.current.value
    const items = [item]
    fireCsEvent({
      category: "Sayfa",
      action: "Engagement",
      label: "Create collection attempt"
    })
    createCollection({variables: {title, items}})
  }

  return <StyledModal
    isOpen={true}
    afterOpen={afterOpenModal}
    onEscapeKeydown={closeModal}
    onBackgroundClick={closeModal}
    contentLabel="Login Popup"
  >
  <Wrapper>
    {loading && <Spinner />}
    {!loading && <React.Fragment>
      <h1 className="text-center">Yeni bir koleksiyon oluşturun</h1>
      {errorDisplay && <Row>
        <ErrorDiv>{errorDisplay}</ErrorDiv>
      </Row>}
      <Row>
        <FormInput ref={titleRef} type="text" autoCapitalize="none"/>
        <FormLabel>Koleksiyon ismi</FormLabel>
      </Row>
      <Row><FormButton onClick={onCreate}>
        Koleksiyonu oluştur
      </FormButton></Row>
    </React.Fragment>}
  </Wrapper>
  </StyledModal>
}

export default Component
